import React from "react";
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid2"
import ReturnToStartScreenTimer from "../Common/ReturnToStartScreenTimer";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {RootState} from "../../../Redux";
import {getLocale, getTranslatatedPropertyValue} from "../../../Utils/helpers";

const OtherServicesClosed = () => {
    const { t } = useTranslation()
    const language = getLocale()

    const openingTimes = useSelector((state: RootState) => getTranslatatedPropertyValue(state.ui.settings.selfService, 'otherServicesOpeningTimes', language))

    return (<>
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className="pageMainContainer">
            <Grid>
            </Grid>
            <Typography variant="h4" gutterBottom>
                {t('selfService.otherServicesClosed')}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                {openingTimes}
            </Typography>
            <ReturnToStartScreenTimer time={5}/>
            <Grid>
            </Grid>
        </Grid>
    </>);
};

export default OtherServicesClosed;
